/**
 * Universal Table Sorting
 *
 * Adds column-header sort. On pages with server-side pagination
 * (search input has class="server"), sort happens via URL navigation
 * (?sort=col&order=asc|desc) and preserves other query params.
 * On non-paginated pages, sort happens in-DOM client-side.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Detect server-side mode via the "server" class on the search input
  const searchInput = document.querySelector('input[name="search"]');
  const serverSide = searchInput && searchInput.classList.contains("server");

  // Find all tables with sortable headers
  const tables = document.querySelectorAll('table');

  tables.forEach(table => {
    const headers = table.querySelectorAll('th.sortable');
    if (headers.length === 0) return; // Skip tables without sortable headers

    const tbody = table.querySelector('tbody');
    if (!tbody) return;

    let currentSort = { column: null, direction: 'asc' };

    headers.forEach(header => {
      header.addEventListener('click', function() {
        const column = this.dataset.column;

        if (serverSide) {
          // URL is the source of truth for sort state on paginated pages.
          // Read current sort/order from URL so a second click on the same
          // header toggles asc → desc (in-memory currentSort gets reset on
          // every page reload, so we can't rely on it here).
          const params = new URLSearchParams(window.location.search);
          const currentColumn = params.get('sort');
          const currentOrder = params.get('order');
          const direction = (currentColumn === column && currentOrder !== 'desc') ? 'desc' : 'asc';

          const url = new URL(window.location);
          url.searchParams.set('sort', column);
          url.searchParams.set('order', direction);
          url.searchParams.set('page', '1'); // Reset to page 1 on new sort
          window.location = url;
        } else {
          // Client-side in-DOM sort (non-paginated tables)
          const direction = (currentSort.column === column && currentSort.direction === 'asc') ? 'desc' : 'asc';
          sortTable(tbody, column, direction);
          updateSortIcons(headers, this, direction);
          currentSort = { column, direction };
        }
      });
    });

    // On server-side pages, reflect the current sort from URL on page load
    if (serverSide) {
      const params = new URLSearchParams(window.location.search);
      const activeColumn = params.get('sort');
      const activeOrder = params.get('order') || 'asc';
      if (activeColumn) {
        const activeHeader = table.querySelector(`th.sortable[data-column="${activeColumn}"]`);
        if (activeHeader) {
          updateSortIcons(headers, activeHeader, activeOrder);
        }
      }
    }
  });

  function sortTable(tbody, column, direction) {
    const rows = Array.from(tbody.querySelectorAll('tr'));

    rows.sort((a, b) => {
      let aVal = a.dataset[column] || '';
      let bVal = b.dataset[column] || '';

      // Auto-detect numeric values
      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        // Numeric sorting
        return direction === 'asc' ? aNum - bNum : bNum - aNum;
      } else {
        // String sorting
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();

        if (aVal < bVal) return direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return direction === 'asc' ? 1 : -1;
        return 0;
      }
    });

    rows.forEach(row => tbody.appendChild(row));
  }

  function updateSortIcons(headers, clickedHeader, direction) {
    // Reset all icons
    headers.forEach(h => {
      const icon = h.querySelector('i');
      if (icon) {
        icon.className = 'fas fa-sort text-muted ms-1';
        icon.style.opacity = '0.3';
      }
    });

    // Update clicked header icon
    const icon = clickedHeader.querySelector('i');
    if (icon) {
      icon.className = `fas fa-sort-${direction === 'asc' ? 'up' : 'down'} text-primary ms-1`;
      icon.style.opacity = '1';
    }
  }

});
